<template>
	<a-popover trigger="click">
		<div slot="content">
			<a-input-search
				v-model="value"
				placeholder="Buscar.."
				enter-button
				@search="search"
			/>
		</div>
		<fa-icon
			:class="[$style.icon, active ? 'text-primary': 'text-muted']"
			icon="search"
			class="ml-2"
		/>
	</a-popover>
</template>

<script>

export default {
	name: 'GTableFilterSearch',
	props: {
		index: {
			type: String,
			required: true
		},
		view: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			value: ''
		};
	},
	computed: {
		query() {
			return this.$query(this.view);
		},
		active() {
			const find = this.query.filter.search({
				field: this.index,
				type: 'text',
				lig: '%'
			});

			if (find) return find[0];
			return false;
		}
	},
	watch: {
		active(val) {
			if (!val) this.value = '';
		}
	},
	created() {
		if (this.active) this.value = this.active.value;
	},
	methods: {
		search(val) {
			this.$query(this.view).filter.delete({
				field: this.index,
				type: 'text',
				lig: '%'
			});

			if (val) {
				this.$query(this.view).filter.add({
					field: this.index,
					type: 'text',
					value: val,
					lig: '%'
				});
			}
		}
	}
};
</script>

<style lang="scss" module>
	.icon{
		font-size: 12px;
	}
</style>
